import { CmsApiStickyHeaderLinksBlockData } from 'modules/cms/api/types/blocks/CmsApiStickyHeaderLinksBlock';
import { CmsAmpLinksBlock } from 'modules/cms/blocks/Amp/CmsAmpLinksBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsStickyHeaderLinksBlock } from './CmsStickyHeaderLinksBlock';

export const CmsStickyHeaderLinksBlockMapping: CmsBlockMapping<CmsApiStickyHeaderLinksBlockData> =
  {
    invariant: [
      {
        prop: 'links',
        msg: 'Links required for sticky header links',
      },
    ],
    width: CmsMappedBlockWidth.FULL,
    Component: CmsStickyHeaderLinksBlock,
    AmpComponent: CmsAmpLinksBlock,
  };
